const JobRequisitionStatus = Object.freeze({
    DRAFT: 1,
    PENDING_APPROVAL: 2,
    ON_HOLD: 3,
    APPROVED: 4,
    REJECTED: 5,
    CANCELLED: 6
});

export const ApprovalLevel = Object.freeze({
    INTERVIEWER: 1,
    HR: 2,
    ADMIN: 3
});

export default JobRequisitionStatus;